import {Component} from '@angular/core';
import {ListViewItem} from "@domain/common/list-view/list-view-item";
import {MatLegacyDialog as MatDialog} from "@angular/material/legacy-dialog";
import {PrestationService} from "@services/admin/frais/prestation.service";
import {ToastrService} from "ngx-toastr";
import {TranslateService} from "@ngx-translate/core";
import {ConfirmService} from "@share/component/confirmation/confirm.service";
import {filter,first} from "rxjs/operators";
import {Result,TypeCodeErreur} from "@domain/common/http/result";
import {Montant} from "@domain/prestation/montant";
import {MontantDetailComponent} from "@components/admin/frais/prestations/prestation-detail/regles-gestion/montant-popin/montant-detail.component";

/**
 * Composant d'affichage d'un item de la liste montant
 *
 * @author Lionel Gimenez
 * @date 06/01/2026
 */
@Component({
    host: {'data-test-id': 'montant-list-item'},
    selector: 'montant-list-item',
    templateUrl: './montant-list-item.component.html'
})
export class MontantListItemComponent extends ListViewItem<Montant> {
    /**
     * Constructeur
     */
    constructor(
        private matDialog: MatDialog,
        private prestationService: PrestationService,
        private toastrService: ToastrService,
        private translateService: TranslateService,
        private confirmService: ConfirmService
    ) {
        super();
    }

    /**
     * Clic sur le montant
     */
    onSelect(): void {
        //Ouverture de la popin de consultation/modification
        this.matDialog.open(MontantDetailComponent,{
            data: {
                montant: this.data
            },
            width: '65%'
        }).afterClosed().subscribe((refresh: boolean) => {
            if (refresh) {
                //Rafraîchissement de la liste
                this.liste.refresh();
            }
        })
    }

    /**
     * Suppression de ce montant
     */
    deleteMontant(): void {
        //Confirmation auprès de l'utilisateur sur la suppression d'un montant
        this.confirmService.showConfirm(this.translateService.instant('global.suppression.confirmation'))
            .pipe(filter(isConfirmed => isConfirmed))
            .subscribe({
                next: () => {
                    //Appel au service
                    this.prestationService.deleteMontant(this.data)
                        .pipe(first())
                        .subscribe((result: Result) => {
                            //Vérification du code d'erreur
                            if (result.codeErreur === TypeCodeErreur.NO_ERROR) {
                                //Toast succès
                                this.toastrService.success(this.translateService.instant('global.success.suppression'));

                                //Rafraîchissement de la liste
                                this.liste.refresh();
                            } else {
                                //Gestion de l'erreur
                                TypeCodeErreur.showError(result.codeErreur,this.translateService,this.toastrService);
                            }
                        });
                }
            });
    }
}
